import template from './project-input-change.pug';

export const ProjectInputChangeComponent = {
  template,
  bindings:{
    workspaceId: '<',
    onChange: '&'
  },
  controller: class ProjectInputChangeComponent {
    constructor($async, $log, Project) {
      'ngInject';

      this.Project = Project;
      this.$log = $log;

      this.getProjects = $async(this.getProjects.bind(this));
      this.project = null;
    }

    $onInit() {
      this.getProjects();
    }

    changed(workspaceId) {
      this.workspaceId = workspaceId;
      this.project = this.projects.find( w => w.id == workspaceId );
      this.onChange({ $event: workspaceId });
    }

    async getProjects() {
      try {
        this.projects = await this.Project.getGroups();

        if (this.workspaceId == null || this.workspaceId == undefined) {
          this.workspaceId = this.Project.currentProjectId();
        }
        this.changed(this.workspaceId);
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      this.modalInstance.close(void(0));
    }

  }
};
